import React from "react";
import { onBackdropMouseDown, onModalPanelMouseDown } from "../../lib/modal";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Languages, Menu, X, LogIn } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_beauty-hub-manage/artifacts/mwvrate5_image.png";

/**
 * Marketplace shared topbar — present on every /m/* page.
 *
 * Per tenant request (2026-06-21): removed both "List your business" and
 * the user/dashboard CTA — the marketplace is a CUSTOMER surface; salon
 * owners reach their dashboard through the dedicated app under
 * `/dashboard` and not through this header.
 */
export default function MpTopbar({ variant = "solid", testId = "mp-topbar" }) {
  const { lang, toggleLang } = useLanguage();
  const [open, setOpen] = React.useState(false);
  const isAr = lang === "ar";
  const isTransparent = variant === "transparent";

  return (
    <header
      data-testid={testId}
      className={`sticky top-0 z-40 backdrop-blur-md ${isTransparent ? "bg-white/70" : "bg-white"} border-b border-[var(--mp-border)]`}
    >
      <div className="mp-container flex items-center justify-between h-[68px]">
        {/* Logo */}
        <Link to="/m" data-testid="mp-logo-link" className="flex items-center gap-2 shrink-0">
          <div className="bg-white rounded-lg p-1 shadow-sm border border-[var(--mp-border)]">
            <img src={LOGO} alt="iSaloon" className="h-9 w-auto object-contain" />
          </div>
        </Link>

        {/* Center nav removed per product spec — was: Hair/Nails/Spa/Bridal tabs. */}

        {/* End actions — desktop. Language toggle + Login link. */}
        <div className="hidden md:flex items-center gap-3">
          <button onClick={toggleLang} data-testid="mp-lang-toggle" className="mp-btn mp-btn-ghost !py-2 !px-3">
            <Languages size={15} />
            <span>{isAr ? "EN" : "ع"}</span>
          </button>
          <Link to="/login" data-testid="mp-login-link" className="mp-btn mp-btn-primary !py-2 !px-4 inline-flex items-center gap-1.5">
            <LogIn size={14} />
            <span>{isAr ? "تسجيل دخول" : "Log in"}</span>
          </Link>
        </div>

        {/* Mobile menu button */}
        <button onClick={() => setOpen(true)} data-testid="mp-mobile-menu" className="md:hidden p-2 rounded-md hover:bg-[var(--mp-cream)]">
          <Menu size={22} />
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="fixed inset-0 z-50 md:hidden" data-testid="mp-mobile-drawer">
          <div className="absolute inset-0 bg-black/40" onMouseDown={(e) => onBackdropMouseDown(e, () => setOpen(false))} />
          <div className="absolute end-0 top-0 w-72 h-full bg-white p-5 flex flex-col gap-3" onMouseDown={onModalPanelMouseDown}>
            <div className="flex items-center justify-between mb-3">
              <img src={LOGO} alt="iSaloon" className="h-9" />
              <button onClick={() => setOpen(false)}><X size={20} /></button>
            </div>
            <Link to="/m" onClick={() => setOpen(false)} className="py-3 border-b border-[var(--mp-divider)]">{isAr ? "اكتشف" : "Discover"}</Link>
            <button onClick={() => { toggleLang(); setOpen(false); }} className="py-3 border-b border-[var(--mp-divider)] text-start flex items-center gap-2">
              <Languages size={15} />{isAr ? "English" : "العربية"}
            </button>
            <Link to="/login" onClick={() => setOpen(false)} data-testid="mp-mobile-login" className="mt-4 mp-btn mp-btn-primary w-full inline-flex items-center justify-center gap-1.5">
              <LogIn size={14} />{isAr ? "تسجيل دخول" : "Log in"}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
